import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from '../../components/v3/TestimonialSlider/TestimonialSlider';
import TruestedSection from '../../components/v4/TrustedSection/TruestedSection';
import LottieIcon from '../../components/v4/LottieIcon';
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";

//animation
import AiInsightAnimation from "../../animations/v3/aiFeatures/AiInsightAnimation.json";

//images
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import arrowRight from "../../images/v4/salesReps/arrowRight.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";


// import aiIcon from "../../images/v4/aiFeatures/aiChatbot/icons/aiIcon.svg";
import aiIcon from "../../images/v4/aiFeatures/aiChatbot/images/aiIcon.png";

import clientScrollGreenBg from "../../images/v4/aiFeatures/aiSalesInsight/images/clientScrollGreenBg.png";
import heroSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/heroSectionBg.png";
import flipSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/flipSectionBg.png";
import tabsSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/tabsSectionBg.png";
import accordianTabsBg from "../../images/v4/aiFeatures/aiChatbot/images/accordianTabsBg.png";
import growingBusinessBg from "../../images/v4/aiFeatures/aiChatbot/images/growingBusinessBg.png";
import benefitSection1Bg from "../../images/v4/aiFeatures/aiSalesInsight/images/benefitSection1Bg.png";
import cardsSectionBg from "../../images/v4/aiFeatures/aiSalesInsight/images/cardsSectionBg.png";

import cardBg1 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardBg1.png";
import cardBg2 from "../../images/v4/aiFeatures/aiKnowledgeBase/images/cardBg2.png";
import cardImg1 from "../../images/v4/aiFeatures/aiSalesInsight/images/cardImg1.webp";
import cardImg2 from "../../images/v4/aiFeatures/aiSalesInsight/images/cardImg2.webp";

import realWorldImg1 from "../../images/v4/aiFeatures/aiSalesInsight/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiSalesInsight/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiSalesInsight/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiSalesInsight/images/realWorldImg4.webp";


import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import growingIcon1 from "../../images/v4/aiFeatures/aiSalesInsight/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/aiFeatures/aiSalesInsight/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/aiFeatures/aiSalesInsight/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/aiFeatures/aiSalesInsight/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/aiFeatures/aiSalesInsight/icons/growingIcon5.svg";
import growingIcon6 from "../../images/v4/aiFeatures/aiSalesInsight/icons/growingIcon6.svg";

import bentoSectionImg1 from "../../images/v4/aiFeatures/aiChatbot/images/bentoSectionImg1.webp";
import bentoSectionBg1 from "../../images/v4/aiFeatures/aiSalesInsight/images/bentoSectionBg1.webp";
import bentoSectionBg2 from "../../images/v4/aiFeatures/aiSalesInsight/images/bentoSectionBg2.webp";
import bentoSectionBg3 from "../../images/v4/aiFeatures/aiSalesInsight/images/bentoSectionBg3.webp";
import bentoSectionBg4 from "../../images/v4/aiFeatures/aiSalesInsight/images/bentoSectionBg4.webp";
import bentoSectionBg5 from "../../images/v4/aiFeatures/aiSalesInsight/images/bentoSectionBg5.webp";

import flipCardImg from "../../images/v4/aiFeatures/aiSalesInsight/images/flipCardImg.webp";




import featureContainerImg from "../../images/v4/aiFeatures/aiSalesInsight/images/featureContainerImg.png";

import flipIcon1 from "../../images/v4/aiFeatures/aiSalesInsight/icons/flipIcon1.svg";
import flipIcon2 from "../../images/v4/aiFeatures/aiSalesInsight/icons/flipIcon2.svg";
import flipIcon3 from "../../images/v4/aiFeatures/aiSalesInsight/icons/flipIcon3.svg";
import flipIcon4 from "../../images/v4/aiFeatures/aiSalesInsight/icons/flipIcon4.svg";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/transparentLogos/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/transparentLogos/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/transparentLogos/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/transparentLogos/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/transparentLogos/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/transparentLogos/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/transparentLogos/client7.png";

const useStyles = makeStyles((theme) => ({
    heroSection: {
        paddingTop: '120px',
        backgroundImage: `url(${heroSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            paddingTop: '0',
            paddingBottom: '0'
        }
    },
    heroSectionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '90%',
        margin: '0 auto',
        gap: '24px',
        textAlign: 'center',
        "& span": {
            // background:
            //     "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
            // WebkitBackgroundClip: "text",
            // WebkitTextFillColor: "transparent",
            display: 'inline-flex',
            alignItems: 'baseline',
            justifyContent: 'flex-start',
            gap: '5px',
            "@media only screen and (max-width: 600px)": {
                "& img": {
                    height: '30px',
                    width: '30px'
                }
            }
        },

    },
    accordianTabs: {
        backgroundImage: `url(${accordianTabsBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "& .headercenterContainer": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "64px",
            textAlign: 'center',
            gap: "30px",
            "& h2": {
                width: "100%",
            },
            "& p": {
                width: "100%",
            },
            "@media (max-width:768px)": {
                flexDirection: "column",
                gap: "18px",
                marginBottom: "55px",
                "& h2": {
                    width: "100%",
                },
                "& p": {
                    width: "100%",
                },
            },
        },
    },
    absoulteCard: {
        position: "absolute",
        margin: "0 auto",
        width: "100%",
        top: "-20%",
        "@media only screen and (max-width: 600px)": {
            top: "-16%",
        },
    },
    tabsSection: {
        backgroundImage: `url(${tabsSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        paddingTop: "260px",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "& $supportBox": {
            position: "absolute",
            top: "-530px",
            "@media only screen and (max-width: 600px)": {
                top: "-800px",
                marginTop: 0,
            },
        },
          "@media only screen and (max-width: 1000px)": {
paddingTop: "300px",
          },
        "@media only screen and (max-width: 600px)": {
            paddingTop: "120px",
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    tabsContainer: {
        width: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
        border: "2px solid #DBDBDB",
        borderRadius: "40px",
        background: "#fff",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "10px",
            padding: "5px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
    },
    tab: {
        width: "33%",
        background: "",
        padding: "18px",
        background: "transparent",
        borderRadius: "40px",
        background: "transparent",
        transition: "0.3s ease",
        cursor: "pointer",
        "&.active": {
            color: "white",
            background:
                "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
        },
        "@media only screen and (max-width: 600px)": {
            minWidth: "max-content",
            padding: "10px 15px",
        },
    },
    tabCard: {
        marginTop: "65px",
        gap: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 600px)": {
            marginTop: "30px",
            flexDirection: "column",
        },
    },
    tabCardLeftContainer: {
        width: "50%",
        display: "flex",
        gap: "40px",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            gap: "20px",
            width: "100%",
        },
    },
    tabCardRightContainer: {
        width: "50%",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },

    tabListContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "30px",
        marginTop: "50px",
        "@media only screen and (max-width: 600px)": {
            gap: "15px",
            marginTop: "20px",
        },
    },
    tabListItem: {
        display: "flex",
        width: "100%",
        margin: "0 auto",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "15px",
        position: "relative",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            gap: "15px",
            alignItems: "flex-start",
        },
    },
    tabListItemContent: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "10px",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        "@media only screen and (max-width: 600px)": {
            width: "100%",
        },
    },
    wpFaq: {
        // paddingTop: "120px",
        "@media only screen and (max-width: 600px)": {
            "& section": {
                padding: "0px 0 0 !important",
            },
        },
    },
    commonPageFooterSection: {
        background:
            " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    partnerSlide: {
        width: "144px !important",
        "& img": {
            width: "144px",
            filter: "brightness(0)",
        },
        "@media only screen and (max-width: 600px)": {
            width: "max-content !important",
            "& img": {
                width: "100px",
            },
        },
    },
    partnerSlider: {
        padding: "10px 0 60px !important",
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "40px !important",
        },
    },
    growingBusiness: {
        backgroundImage: `url(${growingBusinessBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: "80px",
        position: "relative",
        "& .header": {
            width: "55%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            textAlign: "left",
            gap: "32px",
        },
        "& $featureContainer": {
            gap: "20px",
        },
        "@media only screen and (max-width: 600px)": {
            paddingBottom: "50px",
            "& .header": {
                width: "100%",
            },
        },
    },
    broadcastContainerInner: {
        gap: "30px",
        width: "100%",
        display: "flex",
        padding: "0 16rem 0rem 16rem",
        paddingTop: "10px  !important",
        paddingBottom: "10px  !important",
        alignItems: "stretch",
        justifyContent: "flex-start",
        "& swiper-wrapper": {
            alignItems: "stretch !important",
        },

        "& $featureContainer": {
            width: "31%",
            height: "auto  !important",
        },
        "@media only screen and (max-width: 600px)": {
            padding: "0 15px !important",
            paddingBottom: "10px !important",
        },
        "@media only screen and (min-width: 1900px)": {
            paddingLeft: "23rem !important",
            paddingRight: "23rem !important",
        },
    },
    featureContainer: {
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "32%",
        gap: "22px",
        boxShadow: "0px 0px 16px #C1D7DB66",
        borderRadius: "16px",
        background: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        textAlign: "left",
        "& p": {
            width: "90%",
        },
        "@media only screen and (max-width: 600px)": {
            width: "100%",
            "& p": {
                width: "100%",
            },
        },
    },
    trustedSection: {
        "& .trustedHeading": {
            textAlign: 'center'
        }
    },
    cardsSection: {
        backgroundImage: `url(${cardsSectionBg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "& .header": {
            display: "flex",
            marginBottom: "64px",
            width: "100%",
            gap: "32px",
            flexDirection: "column",
            "& h2": {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "5px",
            },
            "& p": {
                width: "80%",
            },
            "@media only screen and (max-width: 600px)": {
                marginBottom: "40px",
            },
        },
        "& .cardImg": {
            "& img": {
                width: "100%",
                height: "100%",
            },
        },
        "@media only screen and (max-width: 600px)": {
            "& .cardImg": {
                width: "100%",
                height: "100%",
                marginBottom: "15px",
                marginTop: "0",
                "& img": {
                    width: "100%",
                    height: "100%",
                },
            },
        },
    },
    bentoContainer: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '20px',
        width: '100%',
        marginTop: '40px',
    },
    bentoRow1: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: '20px',
        width: '100%',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoRow2: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: '20px',
        width: '100%',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoRow3: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        gap: '20px',
        width: '100%',
        "@media only screen and (max-width: 600px)": {
            flexDirection: 'column'
        }
    },
    bentoCard: {
        overflow: 'hidden',
        position: 'relative',
        zIndex: "1",
        display: 'flex',
        flexDirection: "column",
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        gap: '20px',
        borderRadius: '16px',
        backgroundSize: 'cover',
        backgroundPosition: 'top left',
        backgroundRepeat: 'no-repeat',
        minHeight: '330px',
        "& .content": {
            padding: '25px',
            display: 'flex',
            width: '100%',
            flexDirection: "column",
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '12px',
        },
        "@media only screen and (max-width: 600px)": {
            minHeight: '300px'
        },
        "@media only screen and (min-width: 1900px)": {
            minHeight: '380px'
        },
        "&.card1": {
            width: '32%',
            backgroundImage: `url(${bentoSectionBg1})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg1Mob})`,
                width: '100%'
            }
        },
        "&.card2": {
            width: '32%',
            backgroundImage: `url(${bentoSectionBg2})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg2Mob})`,
                width: '100%'
            }
        },
        "&.card3": {
            width: '32%',
            backgroundImage: `url(${bentoSectionBg3})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg3Mob})`,
                width: '100%'
            }

        },
        // "&.card4": {
        //     width: '100%',
        //     backgroundImage: `url(${bentoSectionBg4})`,
        //     "@media only screen and (max-width: 600px)": {
        //         // backgroundImage: `url(${bentoSectionBg4Mob})`,
        //         width: '100%'
        //     },
        //     "& .content": {
        //         width: '50%',
        //         "@media only screen and (max-width: 600px)": {
        //             width: '100%'
        //         },
        //     }
        // },
        "&.card5": {
            width: '49%',
            backgroundImage: `url(${bentoSectionBg4})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg5Mob})`,
                width: '100%'
            }
        },
        "&.card6": {
            width: '49%',
            backgroundImage: `url(${bentoSectionBg5})`,
            "@media only screen and (max-width: 600px)": {
                // backgroundImage: `url(${bentoSectionBg5Mob})`,
                width: '100%'
            }
        },
        "&.blueCard": {
            // background: "#053333",
            // "&:hover": {
            //   boxShadow: "0 0 16px 2px #009A99;",
            // },
            "& .offPrice": {
                background: '#009A99'
            },
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "250px",
                    height: "250px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #1ADAD9 30%, #00aa7c 50%)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "&.regularCard": {
            // background: "#0A2F4F",
            // "&:hover": {
            //   boxShadow: "0 0 16px 2px #208EEC;",
            // },
            "& .offPrice": {
                background: '#208EEC'
            },
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "250px",
                    height: "250px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
                    borderRadius: "50%",
                    filter: "blur(100px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
        "&.purpleCard": {
            // background: "#31114B",
            // "&:hover": {
            //   boxShadow: "0 0 16px 2px #9E5AD5;",
            // },
            "& .offPrice": {
                background: '#9E5AD5'
            },
            "&.glass-effect": {
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: "400px",
                    height: "400px",
                    zIndex: "-1",
                    background: "radial-gradient(circle, #FF8958 0%, #B458FF 100%)",
                    borderRadius: "50%",
                    filter: "blur(200px)",
                    opacity: "var(--before-opacity, 0)",
                    left: "var(--before-left, 0)",
                    top: "var(--before-top, 0)",
                    transition: "opacity 0.3s ease",
                    pointerEvents: "none",
                },
            },
        },
    },
    benefitSection1: {

        backgroundImage: `url(${benefitSection1Bg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        background: "#F7F1FB",
        // paddingTop: '310px',
        "& .centerContainer": {
            display: "flex",
            justifyContent: "center",
            alignItems: 'center',
            flexDirection: 'column',
            gap: "32px",
            width: "80%",
            margin: "0 auto",
            textAlign: "center",
            "& h2": {
                flex: 1,
            },
            "& p": {
                flex: 1,
            },
        },
        "@media only screen and (max-width:  768px)": {
            "& .centerContainer": {
                width: '100%',
                flexDirection: "column",
            },
        },

        "& .benefits": {
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            margin: "60px 0",
            marginBottom: '0',
            "& .imageColumn": {
                width: "33%",

                "& img": {
                    width: "100%",
                },
                "& .featureContainer": {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    gap: "22px",
                    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                    background: "rgba(158, 90, 213, 0.20)",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    marginBottom: "0",
                    minHeight: "48%",
                    "& p": {
                        // color: $black2,
                        width: "90%",
                    },
                    "@media only screen and (max-width: 600px)": {
                        width: "100%",
                        minHeight: "0",
                        "& p": {
                            width: "100%",
                        },
                    },
                    "& .border": {
                        borderTop: '1px solid #fefefe42'
                    }
                },
            },

            "& .featureColumn": {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "33%",
                "& .featureContainer": {
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    gap: "22px",
                    boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                    // background: "rgba(158, 90, 213, 0.20)",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    textAlign: "left",
                    marginBottom: "0",
                    minHeight: "48%",
                    "& p": {
                        // color: $black2,
                        width: "90%",
                    },
                    "@media only screen and (max-width: 600px)": {
                        width: "100%",
                        minHeight: "0",
                        "& p": {
                            width: "100%",
                        },
                    },
                    "& .border": {
                        borderTop: '1px solid #fefefe42'
                    }
                },
                "&:first-child": {
                    "& .featureContainer:first-child": {
                        minHeight: 'auto'
                    },
                    "& .featureContainer:last-child": {
                        minHeight: '52%'
                    },
                },
                "&:last-child": {
                    "& .featureContainer:last-child": {
                        minHeight: 'auto'
                    },
                    "& .featureContainer:first-child": {
                        minHeight: '52%'
                    },
                },
            },

            "@media only screen and (max-width:  768px)": {
                flexDirection: "column",
                gap: "20px",
                marginBottom: "0",

                "& .imageColumn": {
                    width: "100%",
                },

                "& .featureColumn": {
                    width: "100%",
                },
            },
        },
    },
    flipSection: {
        backgroundImage: `url(${flipSectionBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        "& .centerContainer": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "80%",
            margin: "0 auto",
            textAlign: "center",
        },
        "@media only screen and (max-width: 600px)": {
            "& .centerContainer": {
                width: "100%",
            },
        },
    },
    flipCard: {
        background: "linear-gradient(270deg, #0A2F4F 0%, #2576BB 100%)",
        boxShadow: "0 0 20px 0 rgba(1, 15, 29, 0.20)",
        borderRadius: "24px",
        overflow: "hidden",
        display: "flex",
        width: "100%",
        marginTop: '40px',
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "40px",
        "@media only screen and (max-width: 768px)": {
            flexDirection: "column",
            padding: '15px',
            gap: '30px'
        },
    },
    flipCardLeft: {
        width: "50%",
        display: "flex",
        "@media only screen and (max-width: 768px)": {
            width: "100%",
        },
    },
    flipCardRight: {
        width: "50%",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        "@media only screen and (max-width: 768px)": {
            width: "100%",
            padding: "0",
            gap: "20px",
        },
    },
    flipCardRightHeader: {
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
    },
    flipCardPointers: {
        display: "flex",
        gap: "40px",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
    },
    flipCardPointer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "45%",
        "@media only screen and (max-width: 910px)": {
            width: "100%",
        },
    },
    clientScrollSection: {
        backgroundImage: `url(${clientScrollGreenBg})`,
        backgroundPosition: "top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        paddingBottom: '220px',
        "& section": {
            padding: '0 !important'
        }
    },

    bentoSection: {
        background: '#011C33',
        "& .centerContainer": {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "32px",
            width: "100%",
            margin: "0 auto",
            "& h2": {
                widht: '45%',
                "@media only screen and (max-width: 600px)": {
                    width: '100%'
                }
            },
            "& p": {
                widht: '45%',
                "@media only screen and (max-width: 600px)": {
                    width: '100%'
                }

            },
            "@media only screen and (max-width: 600px)": {
                flexDirection: 'column'
            }
        },
    }
}));

const AiPoweredSales = () => {

    // desclaration
    const classes = useStyles();
    const [activeAccordian, setActiveAccordian] = useState(0);
    const [activeRealWorld, setActiveRealWorld] = useState(0);

    const { ref, inView } = useInView({
        threshold: 0.5, // adjust as needed
        triggerOnce: false,
    });

    // glass-effect-code
    useEffect(() => {
        // Select all cards that should have the effect
        const cardsToAnimate = [

            ...document.querySelectorAll(`.${classes.bentoCard}.purpleCard`), // Add regularCards
            ...document.querySelectorAll(`.${classes.bentoCard}.blueCard`),
            ...document.querySelectorAll(`.${classes.bentoCard}.regularCard`), // Add regularCards
        ];

        cardsToAnimate.forEach((card) => {
            if (!card) return;

            card.classList.add("glass-effect");

            // Set initial top-right position for the glass effect
            const setInitialPosition = () => {
                const rect = card.getBoundingClientRect();
                const topRightX = rect.width - 150; // Adjust this value to position from right edge
                const topRightY = 0; // Top position

                card.style.setProperty("--before-left", `${topRightX}px`);
                card.style.setProperty("--before-top", `${topRightY}px`);
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Call it initially
            setInitialPosition();

            let lastX = null;
            let lastY = null;

            const handleMouseMove = (e) => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;

                lastX = x;
                lastY = y;

                card.style.setProperty("--before-left", `${x - 75}px`);
                card.style.setProperty("--before-top", `${y - 75}px`);
            };

            const handleMouseEnter = () => {
                if (lastX !== null && lastY !== null) {
                    card.style.setProperty("--before-left", `${lastX - 75}px`);
                    card.style.setProperty("--before-top", `${lastY - 75}px`);
                }
                card.style.setProperty("--before-opacity", "0.8");
            };

            const handleMouseLeave = () => {
                card.style.setProperty("--before-opacity", "0.8");
            };

            // Store handlers on the card element for cleanup
            card.handlers = {
                mousemove: handleMouseMove,
                mouseenter: handleMouseEnter,
                mouseleave: handleMouseLeave,
                resize: setInitialPosition,
            };

            // Add event listeners
            card.addEventListener("mousemove", handleMouseMove);
            card.addEventListener("mouseenter", handleMouseEnter);
            card.addEventListener("mouseleave", handleMouseLeave);
            window.addEventListener("resize", setInitialPosition);
        });

        // Cleanup
        return () => {
            cardsToAnimate.forEach((card) => {
                if (!card) return;

                const handlers = card.handlers;
                if (handlers) {
                    card.removeEventListener("mousemove", handlers.mousemove);
                    card.removeEventListener("mouseenter", handlers.mouseenter);
                    card.removeEventListener("mouseleave", handlers.mouseleave);
                    window.removeEventListener("resize", handlers.resize);
                }
            });
        };
    }, [classes]);
    // glass-effect-code

    //scrollableCards
    useEffect(() => {
        const cards = document.querySelectorAll(".card");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const card = entry.target;
                    const currentIndex = Array.from(cards).indexOf(card);

                    if (entry.isIntersecting) {
                        // Remove all previous classes first
                        cards.forEach((c) => {
                            c.classList.remove(
                                "is-previous-1",
                                "is-previous-2",
                                "is-previous-3",
                                "is-previous-4"
                            );
                        });

                        // Add appropriate classes based on distance from current card
                        cards.forEach((c, index) => {
                            if (index < currentIndex) {
                                const difference = currentIndex - index;
                                if (difference <= 4) {
                                    // Only apply effects to 4 cards back
                                    c.classList.add(`is-previous-${difference}`);
                                }
                            }
                        });
                    }
                });
            },
            {
                root: null,
                threshold: 0.5,
                rootMargin: "0px",
            }
        );

        cards.forEach((card) => observer.observe(card));

        return () => observer.disconnect();
    }, []);
    //scrollableCards

    // data

    const tabContentData = [
        {
            tabContent: [
                {
                    title: "Order queries simplified",
                    content:
                        "AI summaries help teams resolve questions faster.",
                    alt: "E-commerce AI CRM",
                },
                {
                    title: "Product info on demand",
                    content:
                        "Share catalogues, prices, and stock details instantly.",
                    alt: "E-commerce AI CRM",
                },
                {
                    title: "Smart follow-ups",
                    content:
                        "AI auto-creates tasks from abandoned cart or inquiry messages.",
                    alt: "E-commerce AI CRM",
                },
                {
                    title: "Consistent support",
                    content:
                        "Ensure every buyer gets the right information, every time.",
                    alt: "E-commerce AI CRM",
                },
            ],
            img: realWorldImg1,
            alt: "AI CRM for E-commerce",
            subtitle:
                "Boost conversions and customer satisfaction with real-time AI insights. Automate follow-ups and improve response times across WhatsApp, email, and chat.",
        },
        {
            tabContent: [
                {
                    title: "Admission follow-ups",
                    content:
                        "AI detects next steps and sends reminders.",
                    alt: "AI CRM for Education",
                },
                {
                    title: "Student query summaries",
                    content:
                        "Get quick overviews of messages from students or parents.",
                    alt: "AI CRM for Education",
                },
                {
                    title: "Centralised information",
                    content:
                        "Find documents, FAQs, and past chats instantly.",
                    alt: "AI CRM for Education",
                },
                {
                    title: "Personalised replies",
                    content:
                        "Use conversational AI to tailor answers to each inquiry.",
                    alt: "AI CRM for Education",
                },
            ],
            img: realWorldImg2,
            alt: "AI CRM for Education",
            subtitle:
                "Manage admissions and student communication more efficiently with AI for sales insights.",
        },
        {
            tabContent: [
                {
                    title: "Appointment tracking",
                    content:
                        "AI creates tasks from patient messages or requests.",
                    alt: "AI CRM for Healthcare",
                },
                {
                    title: "Message summaries",
                    content:
                        "Doctors and staff see key points without reading long threads.",
                    alt: "AI CRM for Healthcare",
                },
                {
                    title: "Easy access to history",
                    content:
                        "Review past interactions instantly inside the CRM.",
                    alt: "AI CRM for Healthcare",
                },
                {
                    title: "Faster responses",
                    content:
                        "Help patients quickly with AI-suggested replies.",
                    alt: "AI CRM for Healthcare",
                },
            ],
            img: realWorldImg3,
            alt: "AI CRM for Healthcare",
            subtitle:
                "Use conversational AI to improve patient communication and care coordination.",
        },
        {
            tabContent: [
                {
                    title: "Lead qualification",
                    content:
                        "AI highlights serious buyers and tags intent.",
                    alt: "AI CRM for Real Estate",
                },
                {
                    title: "Follow-up automation",
                    content:
                        "Site visits or paperwork tasks are created automatically.",
                    alt: "AI CRM for Real Estate",
                },
                {
                    title: "Property sharing",
                    content:
                        "Send brochures and details directly from the CRM.",
                    alt: "AI CRM for Real Estate",
                },
                {
                    title: "Clear communication trail",
                    content:
                        "View all buyer messages in one place.",
                    alt: "AI CRM for Real Estate",
                },
            ],
            img: realWorldImg4,
            alt: "AI CRM for Real Estate",
            subtitle:
                "Stay on top of every inquiry and close deals faster with AI for sales insights.",
        },
    ];


    const partners = [
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
        { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
        { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
        { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
        { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
        {
            icon: partnerIcon6,
            alt: "mustard seed systems corporation - Pepper Cloud Customer",
        },
        {
            icon: partnerIcon7,
            alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
        },
        { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    ];

    const faqs = [
        {
            question: "What are AI insights in a CRM?",
            answer:
                "AI insights uses AI for sales insights to read your chats, emails, and WhatsApp messages. It creates short summaries, tags key points, and sets follow-up tasks automatically in your CRM.",
        },
        {
            question: "How does conversational AI help with sales?",
            answer:
                "Conversational AI understands your chats and suggests smart actions like follow-ups or replies. It saves time and helps you stay on top of every lead.",
        },
        {
            question: "Can it summarise long conversations?",
            answer:
                "Yes. It turns long chats into short notes, so sales reps can quickly understand what happened—without reading everything.",
        },
        {
            question: "Does it work with WhatsApp and email?",
            answer:
                "Yes, it works with WhatsApp, email, and chat. AI pulls useful info from these messages into your CRM.",
        },
        {
            question: "Can it create follow-up tasks?",
            answer:
                "Yes. The AI finds next steps in messages and adds them as tasks, so you never miss a follow-up.",
        },
        {
            question: "Is the AI always accurate?",
            answer:
                "The AI is very smart, but you can always review and change the suggestions if needed.",
        },
        {
            question: "Is my data safe?",
            answer:
                "Yes. Pepper Cloud uses strong security to protect your data. Everything is encrypted and stored safely inside your CRM.",
        },
    ];

    const growingList = [
        {
            icon: growingIcon1,
            background: "#F9F1FF",
            heading: "Automate notes and task creation",
            text: "AI reads chats and turns them into notes and tasks—saving your team time and effort.",
        },
        {
            icon: growingIcon2,
            background: "#F4FAFF",
            heading: "Minimise data entry errors",
            text: "Fewer mistakes from manual work—AI adds information to your CRM directly, so everything stays accurate.",
        },
        {
            icon: growingIcon3,
            background: "#FFF5F1",
            heading: "Ensure team alignment",
            text: "Keep your team on the same page—everyone can see what was discussed without reading the whole chat.",
        },
        {
            icon: growingIcon4,
            background: "#F9F1FF",
            heading: "Improve customer response times",
            text: "Faster replies to customers—AI shows you the key points quickly, so you can respond right away.",
        },
        {
            icon: growingIcon5,
            background: "#FFF5E8",
            heading: "Enable smart search and sharing",
            text: "Easy to search and share information—AI tags important words and questions, making chats easy to find later.",
        },
        {
            icon: growingIcon6,
            background: "#F9F1FF",
            heading: "Stay on top of follow-ups",
            text: "Helps with follow-ups—AI spots follow-up points in chats and creates reminders, so nothing gets missed.",
        },
    ];
    const capabilities = [
        {
            heading: "Conversational AI solving everyday sales pain points",
            desc: "Manual data entry and delayed responses slow down your sales. With AI for sales insights, Pepper Cloud streamlines your workflow using conversational AI. It reads customer chats and emails, then adds follow-ups, questions, and updates directly into your CRM using AI-powered conversation intelligence.",
            background: 'linear-gradient(99deg, #0D47C0 0%, #028376 100%)',
            img: cardImg1,
            alt: "AI Insights feature",
        },
        {
            heading: "What are AI insights?",
            desc: "AI Insights is a smart feature in Pepper Cloud that uses conversational AI to turn chats, emails, and messages into clear summaries and tasks. It automatically tags keywords, detects follow-ups, and updates your CRM in real time. With AI for sales insights, your team spends less time reading and more time selling. It’s like having an intelligent assistant built right into your CRM.",

            background: 'linear-gradient(99deg, #31114B 2.21%, #783CA8 98.14%)',
            img: cardImg2,
            alt: "Conversational AI for sales",
        },
    ];

    const clientScrollData = {
        title: "Trusted by top brands across industries",
        backgroundImage: "",
        logos: [
            {
                img: clientLogo1,
            },
            {
                img: clientLogo2,
            },
            {
                img: clientLogo3,
            },
            {
                img: clientLogo4,
            },
            {
                img: clientLogo5,
            },
            {
                img: clientLogo6,
            },
            {
                img: clientLogo7,
            },
        ],
        directions: ["left", "right", "left"],
        speeds: [0.8, 0.4, 0.8],
    };

    return (
        <main>
            <SEO
                title={
                    "AI for Sales Insights with Conversational AI | Pepper Cloud"
                }
                pathname={
                    "https://peppercloud.com/best-ai-crm-features/ai-chatbot-for-crm/"
                }
                keywords="ai-powered knowledge base, ai-powered conversation intelligence,ai for sales insights,Conversational AI"
                description={"Boost sales with Pepper Cloud conversational AI. Get real-time sales insights, auto tasks, summaries, and follow-ups—all inside your CRM."}
                ogData={{
                    "og:image": [
                        "/meta/og/1X1/home.png",
                        "/meta/og/1024X512/home.png",
                        "/meta/og/1200X630/home.png",
                    ],
                }}
                jsonLd={[
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Pepper Cloud",
                        legalName: "Pepper Cloud PTE LTD",
                        url: "https://peppercloud.com/",
                        logo: "https://peppercloud.com/icons/logo.png",
                        foundingDate: "2017",
                        address: [
                            {
                                "@type": "PostalAddress",
                                streetAddress: "#04-01/02",
                                addressLocality: "Blk 79 Ayer Rajah Crescent",
                                addressRegion: "SG",
                                postalCode: "139955",
                                addressCountry: "Singapore",
                            },
                            {
                                "@type": "PostalAddress",
                                streetAddress:
                                    "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                                addressLocality: "Bengaluru",
                                addressRegion: "KA",
                                postalCode: "560095",
                                addressCountry: "India",
                            },
                        ],
                        contactPoint: {
                            "@type": "ContactPoint",
                            contactType: "customer support",
                            telephone: "+6566562616",
                            email: ["sales@peppercloud.com", "support@peppercloud.com"],
                        },
                        sameAs: [
                            "https://twitter.com/peppercloudpte",
                            "https://www.linkedin.com/company/peppercloud/",
                            "https://www.facebook.com/PepperCloudPteLtd",
                            "https://www.instagram.com/pepper.cloud/",
                        ],
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        name: "AssistAI",
                        description:
                            "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
                        thumbnailUrl: [
                            "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
                        ],
                        uploadDate: "2024-12-02",
                        contentUrl:
                            "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
                        publisher: {
                            "@type": "Organization",
                            name: "Pepper Cloud",
                            logo: {
                                "@type": "ImageObject",
                                url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                                width: "",
                                height: "",
                            },
                        },
                        duration: "PT1M12S",
                    },
                    {
                        "@context": "https://schema.org/",
                        "@type": "FAQPage",
                        mainEntity: [
                            {
                                "@type": "Question",
                                name: "What are AI insights in a CRM?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "AI insights uses AI for sales insights to read your chats, emails, and WhatsApp messages. It creates short summaries, tags key points, and sets follow-up tasks automatically in your CRM.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "How does conversational AI help with sales?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Conversational AI understands your chats and suggests smart actions like follow-ups or replies. It saves time and helps you stay on top of every lead.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Can it summarise long conversations?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. It turns long chats into short notes, so sales reps can quickly understand what happened—without reading everything.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Does it work with WhatsApp and email?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes, it works with WhatsApp, email, and chat. AI pulls useful info from these messages into your CRM.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Can it create follow-up tasks?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. The AI finds next steps in messages and adds them as tasks, so you never miss a follow-up.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Is the AI always accurate?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "The AI is very smart, but you can always review and change the suggestions if needed.",
                                },
                            },
                            {
                                "@type": "Question",
                                name: "Is my data safe?",
                                acceptedAnswer: {
                                    "@type": "Answer",
                                    text: "Yes. Pepper Cloud uses strong security to protect your data. Everything is encrypted and stored safely inside your CRM.",
                                },
                            }
                        ],
                    },
                ]}
            />
            <section className={classes.heroSection}>
                <div className='container'>
                    <div className={classes.heroSectionContainer}>
                        <motion.h1
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-semibold font-white font-64"> <span> <LazyImage source={aiIcon} alt={"AssistAi - Ai crm"} />AI </span> for sales insights that drive real conversations</motion.h1>
                        <motion.p initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }} className='font-white font-wix-regular font-20'>Pepper Cloud delivers AI for sales insights that help your team move faster and close smarter. With conversational AI built into your CRM, every chat becomes action-ready.</motion.p>
                        <Link to="/contact/" className="font-18 font-white font-wix-regular primaryButton">Book a free demo</Link>
                        <LottieIcon
                            autoplay
                            loop
                            animationData={AiInsightAnimation}
                            hover={false}
                            play
                        />
                    </div>
                </div>
                <div className='container'>
                    <LazyImage alt="AI sales insights dashboard" source={bentoSectionImg1} style={{ marginBottom: '40px' }} height={'100%'} width={'100%'} />
                </div>
            </section>
            <section className={classes.cardsSection}>
                <div className="container">
                    <div className="header">
                        <motion.h2
                            className="font-wix-semibold font-56 font-white"
                            initial={{ opacity: 1, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            AI insights that understand, act, and optimise your sales process
                        </motion.h2>
                    </div>
                    <ul id="cards">
                        {capabilities.map((data, index) => (
                            <li className="card" id={`card-${index + 1}`}>
                                <div
                                    className="card-content"
                                    style={{
                                        background: `${data.background}`,

                                    }}
                                >
                                    <div className="cardImg">
                                        <img alt={data.alt} src={data.img} />
                                    </div>
                                    <div className="cardContentData">
                                        <h3 className="cardHeading font-wix-medium">
                                            {data.heading}
                                        </h3>
                                        <p className="cardDesciption">{data.desc}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
            <section className={classes.benefitSection1}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            What AI for sales insights can do for your team

                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            Let your sales and support teams work smarter and faster with Pepper Cloud’s conversational AI. Here’s the impact real teams have seen
                        </motion.p>
                    </div>

                    <div className="benefits">
                        <div className="featureColumn">
                            <div className="featureContainer" style={{ background: 'radial-gradient(50% 100% at 50% 0%, rgba(158, 90, 213, 0.80) 0%, rgba(158, 90, 213, 0.00) 100%), linear-gradient(180deg, rgba(158, 90, 213, 0.20) 0%, rgba(158, 90, 213, 0.16) 100%)' }} >
                                <p className='font-wix-semibold font-56 font-white'>25%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    drop in missed follow-ups
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    AI detects next steps in real time—so nothing gets forgotten.
                                </p>
                            </div>

                            <div className="featureContainer" style={{ background: 'linear-gradient(127deg, #31114B 4.23%, #783CA8 100%)' }}>
                                <p className='font-wix-semibold font-56 font-white'>35%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    less time spent reading long conversations
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    Summaries let teams understand chats quickly without going through every message.
                                </p>
                            </div>
                        </div>

                        <div className="imageColumn">
                            <div className="featureContainer" style={{ background: 'linear-gradient(127deg, #0A2F4F 3.57%, #2576BB 100%)' }}>
                                <p className='font-wix-semibold font-56 font-white'>40%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    faster follow-up time
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                   AI auto-creates follow-up tasks from chats in real time, so nothing gets missed.
                                </p>
                                <LazyImage
                                    source={featureContainerImg}
                                    alt={"Conversational AI in CRM"}
                                    width={"100%"}
                                />
                            </div>

                        </div>

                        <div className="featureColumn">
                            <div className="featureContainer" style={{ background: "linear-gradient(127deg, #053333 1.96%, #009A99 100%)" }}>
                                <p className='font-wix-semibold font-56 font-white'>28%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    improvement in lead conversion rates
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    Smart insights help reps focus on hot leads and act at the right time.
                                </p>
                            </div>
                            <div className="featureContainer" style={{ background: 'radial-gradient(50% 100% at 50% 0%, rgba(0, 154, 153, 0.80) 0%, rgba(0, 154, 153, 0.00) 100%), linear-gradient(180deg, rgba(0, 154, 153, 0.20) 0%, rgba(0, 154, 153, 0.16) 100%)' }}>
                                <p className='font-wix-semibold font-56 font-white'>30%</p>
                                <p className="font-wix-medium font-24 font-white">
                                    better CRM data quality
                                </p>
                                <div className='border' />
                                <p className="font-wix-regular font-16 font-white">
                                    With automated updates and tagging, records stay clean and up-to-date.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.growingBusiness}>
                <div className="container">
                    <div className="header">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-black1"
                        >
                            Benefits of using AI insights

                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-18 font-black1"
                        >
                            AI for sales insights helps your team work faster and smarter. With the help of conversational AI, you save time, avoid mistakes, and never miss a follow-up.
                        </motion.p>
                    </div>
                </div>
                <Swiper
                    slidesPerView={3.3}
                    // centeredSlides={true}
                    spaceBetween={30}
                    grabCursor={true}
                    loop={false}
                    speed={5000}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    // freeMode={true}
                    className={classes.broadcastContainerInner}
                    breakpoints={{
                        // For smaller screens (mobile)
                        0: {
                            slidesPerView: 1.3,
                            slidesPerGroup: 1,
                            freeMode: true,
                            grabCursor: false,
                            allowTouchMove: true,
                            spaceBetween: 10,
                        },
                        // For larger screens (desktop)
                        768: {
                            slidesPerView: 3.3,
                            centeredSlides: false,
                            spaceBetween: 30,
                            grabCursor: true,
                        },
                    }}
                >
                    {growingList.map((feature) => (
                        <SwiperSlide
                            className={classes.featureContainer}
                        //   style={{ background: feature.background }}
                        >
                            <LazyImage
                                source={feature.icon}
                                alt={"AI summarising customer conversations"}
                                className={classes.featureIcon}
                            // alt={listItem.alt}
                            />
                            <p className="font-wix-semibold font-24 color-black1">
                                {feature.heading}
                            </p>
                            <p className="font-wix-mediu font-18 color-black1">
                                {feature.text}
                            </p>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
            </section>
            <section className={classes.bentoSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Pepper Cloud is the best AI CRM for sales insights
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="font-wix-regular font-18 font-white"
                        >
                            Pepper Cloud does more than just store customer chats. It uses conversational AI to turn messages into useful insights, tasks, and updates—so your team can stay ahead and respond faster.

                        </motion.p>
                    </div>
                    <div className={classes.bentoContainer}>
                        <div className={classes.bentoRow1}>
                            <div className={clsx(classes.bentoCard, 'card1', "regularCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">AI support from start to finish From the first message to closing a deal, AI helps at every step with smart tips and reminders.</p>
                                </div>
                            </div>
                            <div className={clsx(classes.bentoCard, 'card2', "purpleCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Smart insights based on customer needs AI understands what your customer is asking and shows helpful suggestions.</p>

                                </div>
                            </div>
                            <div className={clsx(classes.bentoCard, 'card3', "regularCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Better teamwork and handovers Summaries and key points help your team members stay updated and take over easily.</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.bentoRow3}>
                            <div className={clsx(classes.bentoCard, 'card5', "purpleCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Fits your way of working You can adjust how AI adds notes, sets tasks, and sends updates—based on how your team works.</p>

                                </div>
                            </div>
                            <div className={clsx(classes.bentoCard, 'card6', "blueCard")}>
                                <div className="content">
                                    <p className="font-18 font-wix-regular font-white">Real-time visibility across channels whether it’s WhatsApp, email, or chat, AI brings everything into one place for a unified view.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.flipSection}>
                <div className='container'>
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Key Features of AI for Sales Insights
                        </motion.h2>
                    </div>
                    <div
                        className={classes.flipCard}
                    >
                        <div className={classes.flipCardLeft}>
                            {/* keep your LazyImage usage */}
                            <LazyImage
                                source={flipCardImg}
                                width={"100%"}
                                alt="AI extracting sales action points"
                            />
                        </div>

                        <div className={classes.flipCardRight}>
                            <div className={classes.flipCardRightHeader}>
                                {/* <h2
                                    className="font-40 font-wix-medium color-black1"
                                    style={{ margin: 0 }}
                                >
                                    {card.heading}
                                </h2> */}
                                <p
                                    className="font-18 font-wix-regular font-white"
                                >
                                    The AI insights feature of Pepper Cloud is built to simplify how your team manages customer conversations across WhatsApp, email, and chat. It uses conversational AI to extract what matters—so your team can move faster and sell smarter.
                                </p>
                            </div>

                            <div className={classes.flipCardPointers}>

                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="AI extracting sales action points" source={flipIcon1} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Smart conversation summarisation
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        AI turns long conversations into clear summaries, saved in your CRM for quick context.
                                    </p>
                                </div>
                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="AI extracting sales action points" source={flipIcon2} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Seamless CRM integration
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Insights, summaries, and tasks sync automatically into your Pepper Cloud CRM workflows.
                                    </p>
                                </div>
                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="AI extracting sales action points" source={flipIcon3} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Keyword and question extraction
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        AI tags key terms and questions from messages for easy search and reference.
                                    </p>
                                </div>
                                <div className={classes.flipCardPointer}>
                                    <LazyImage alt="AI extracting sales action points" source={flipIcon4} />
                                    <p
                                        className="font-18 font-wix-semibold font-white"
                                        style={{ margin: 0 }}
                                    >
                                        Multi-channel compatibility
                                    </p>
                                    <p
                                        className="font-16 font-wix-regular font-white"
                                        style={{ margin: 0 }}
                                    >
                                        AI Insights unifies WhatsApp, email, and chat into one smart dashboard.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className={classes.clientScrollSection}>
                <ClientScroll
                    {...clientScrollData}
                    darkLayout={true}
                    classname="dark"
                />
            </section>
            <section className={classes.tabsSection}>
                <div className={classes.absoulteCard}>
                    <TruestedSection shadow={true} background={true} />
                </div>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-56 font-white"
                        >
                            Applications & use cases of AI for sales insights
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-regular font-20 font-white"
                        >
                            AI for sales insights transforms how different industries manage conversations, follow-ups, and customer engagement. With built-in conversational AI, Pepper Cloud enables faster responses, better collaboration, and smarter selling—across every touchpoint.
                        </motion.p>
                        <div className={classes.tabsContainer}>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 0 && "active"
                                )}
                                onClick={() => setActiveRealWorld(0)}
                            >
                                E-commerce
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 1 && "active"
                                )}
                                onClick={() => setActiveRealWorld(1)}
                            >
                                Healthcare
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 2 && "active"
                                )}
                                onClick={() => setActiveRealWorld(2)}
                            >
                                Real estate
                            </div>
                            <div
                                className={clsx(
                                    classes.tab,
                                    "font-wix-medium",
                                    "font-20",
                                    activeRealWorld === 3 && "active"
                                )}
                                onClick={() => setActiveRealWorld(3)}
                            >
                                Education
                            </div>
                        </div>
                    </div>
                    <div className={classes.tabCard}>
                        <div className={classes.tabCardLeftContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <div>
                                            <motion.p
                                                initial={{ opacity: 0, x: -20 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="font-wix-regular font-18 font-white"
                                            >
                                                {listItem.subtitle}
                                            </motion.p>
                                            <div className={classes.tabListContainer}>
                                                {listItem.tabContent.map((item) => (
                                                    <motion.div
                                                        initial={{ opacity: 0, x: -20 }}
                                                        whileInView={{ opacity: 1, x: 0 }}
                                                        transition={{ duration: 0.3 }}
                                                        className={classes.tabListItem}
                                                    >
                                                        <LazyImage
                                                            source={greenCheckCircle}
                                                            className={classes.tabIcon}
                                                            alt={item.alt}
                                                        />
                                                        <div className={classes.tabListItemContent}>
                                                            <p className="font-wix-semibold font-18 font-white">
                                                                {item.title}:
                                                            </p>
                                                            <p className="font-wix-regular font-18 font-white">
                                                                {item.content}
                                                            </p>
                                                        </div>
                                                    </motion.div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                        <div className={classes.tabCardRightContainer}>
                            {tabContentData.map(
                                (listItem, index) =>
                                    index === activeRealWorld && (
                                        <motion.div
                                            initial={{ opacity: 1, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                        // className={classes.aiSectionRight}
                                        >
                                            <LazyImage
                                                source={listItem.img}
                                                alt={listItem.alt}
                                                width={"100%"}
                                            />
                                        </motion.div>
                                    )
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <TestimonialSlider desc={"Discover how businesses are transforming customer engagement with Pepper Cloud."} heading={"Real stories. Real results."} noButton={true} />
            <section className={classes.trustedSection}>
                <div className='container'>
                    <div className="trustedHeading">
                        <motion.h3
                            initial={{ opacity: 1, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                            className="font-wix-semibold font-24 font-black1"
                        >
                            Trusted by leading businesses for outstanding efficiency
                        </motion.h3>
                    </div>
                </div>
                <Swiper
                    className={classes.partnerSlider}
                    slidesPerView="auto"
                    spaceBetween={60}
                    loop={true}
                    speed={2000}
                    modules={[Autoplay]}
                    allowTouchMove={false}
                    autoplay={{
                        delay: 100,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                >
                    {partners.map((partner) => (
                        <SwiperSlide className={classes.partnerSlide}>
                            <img src={partner.icon} alt={partner.alt} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
            <div className={classes.wpFaq}>
                <FaqSection
                    backgroundColor={"#E0EFFD"}
                    heading={"Frequently asked questions on AI insights"}
                    faqs={faqs}
                />
            </div>
            <section className={classes.commonPageFooterSection}>
                <div className="container">
                    <div className="centerContainer">
                        <motion.h2
                            className="font-wix-medium font-56 font-white"
                            initial={{ opacity: 1, y: 30 }}
                            transition={{ duration: 0.5 }}
                            whileInView={{ opacity: 1, y: 0 }}
                        >
                            Unlock AI-powered sales insights with Pepper Cloud
                        </motion.h2>
                        <Link
                            className="primaryButton font-20 font-wix-medium font-white"
                            to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                             style={{padding:'8px 32px'}}
                        >
                            Get started
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default AiPoweredSales